import { ICellRendererParams } from '@ag-grid-community/core';
import { ToastType } from '@components/Toast';
import { ILoadBoardViewModel } from '@store/loadboard';
import { quickPostLoad } from '@store/orders/actions/postLoadActions';
import { userStore } from '@store/user';
import { handleToast } from '@utils/utils';
import { Show } from 'solid-js';

const RenderPostings = (data: ICellRendererParams<ILoadBoardViewModel>) => {
  return (
    <Show when={data.data} fallback={<></>}>
      <div class="flex items-center justify-center">
        <input
          type="checkbox"
          class="w-4 h-4 accent-[#123b50] checked:opacity-100 opacity-25 hover:cursor-pointer"
          checked={Boolean(data.data?.postingId)}
          onChange={() => {
            if (Boolean(userStore.user.postingGroupId)) {
              void quickPostLoad(
                data.data?.loadId as number,
                data.data?.postingId as number,
                data.data?.loadNumber,
              );
            } else {
              handleToast(
                ToastType.Error,
                'Cannot Post, No Posting Group Configured',
              );
            }
          }}
        />
      </div>
    </Show>
  );
};

export default RenderPostings;
